export default "__VITE_ASSET__Bj0npCRu__";